



















































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import dayjs from 'dayjs'
import { ApiService } from '@/api/api.service'
import { getOperationID } from '@/api/operations'
import { getBoUrl } from '@/api/http-constants'
import { UserModule } from '@/store/modules/user'
import { TicketModule } from '@/store/modules/ticket'
import Plan from '@/components/Dashboard/Plan.vue'
import Alert from '@/components/Alert.vue'
import FlipCountdown from 'vue2-flip-countdown'

@Component({
    components: {
        Plan,
        Alert,
        FlipCountdown,
    },
})
export default class Progope extends Vue {
    image = null
    promoterImage = null
    name = null
    url = null
    phase = 2
    endPhase2Date: string = null
    phase3Countdown: string = null
    studyCountdown: string = null
    deliveryCountdown: string = null
    status: 'pending' | 'refused' | 'validated' = 'pending'
    hasPlans: boolean = false
    opeId: number = null
    openedSteps: number[] = []

    // --- Admin models ---
    isAdmin: boolean = false
    purchaseLetterModelFile: File = null
    purchaseLetterModelError: string = null
    purchaseLetterModelSuccess: string = null
    brsAttestationModelFile: File = null
    brsAttestationModelError: string = null
    brsAttestationModelSuccess: string = null

    async created() {
        const apiService = new ApiService()
        this.opeId = await getOperationID()

        if (UserModule.token == undefined) {
            UserModule.Init()
        }

        this.isAdmin = !!(UserModule as any).roles && (UserModule as any).roles.includes('ROLE_ADMIN')

        const respOpe = await apiService.getUserOperation(
            UserModule.userInfos.id,
            this.opeId
        )

        const ope = respOpe.data.operation

        this.hasPlans = respOpe.data.blueprints.filter((b: any) => b.isUploadedByAdmin).length > 0

        this.image = `${getBoUrl()}${ope.imagePath}?t=${new Date().valueOf()}`

        this.promoterImage = ope.promoterLogoPath
            ? `${getBoUrl()}${ope.promoterLogoPath}?t=${new Date().valueOf()}`
            : null

        this.name = ope.name
        this.url = ope.url

        this.phase = respOpe.data.phase

        if (ope.phase3Date) {
            this.endPhase2Date = ope.phase3Date.replace('T', ' ').slice(0, -6)
        }

        if (ope.phase3Countdown) {
            this.phase3Countdown = ope.phase3Countdown
                .replace('T', ' ')
                .slice(0, -6)
        }

        if (ope.studyStartDate) {
            this.studyCountdown = (ope.studyStartDate as any).replace('T', ' ').slice(0, -6)
        }

        if (ope.deliveryDate) {
            this.deliveryCountdown = (ope.deliveryDate as any).replace('T', ' ').slice(0, -6)
        }

        const buyerResp = await apiService.getBuyer(UserModule.userInfos.id)
        const buyerStatus = buyerResp.data.status

        if (buyerStatus !== null) {
            this.status = buyerStatus
        }

        // Open the current active step by default
        this.openedSteps = [this.activePhase]
    }

    get activePhase(): number {
        return TicketModule.phase
    }

    toggleStep(step: number) {
        const idx = this.openedSteps.indexOf(step)
        if (idx === -1) {
            this.openedSteps.push(step)
        } else {
            this.openedSteps.splice(idx, 1)
        }
    }

    isStepOpen(step: number): boolean {
        return this.openedSteps.indexOf(step) !== -1
    }

    showPlanModal() {
        const $planModal = $(this.$refs.planModal) as any
        $planModal.modal('show')
    }

    closePlanModal() {
        const $planModal = $(this.$refs.planModal) as any
        $planModal.modal('hide')
    }

    handleAlert(level, msg) {
        ;(<Alert>this.$refs.alert).handleAlert(level, msg)
    }

    uploadBrsAttestationModel() {
        if (!this.brsAttestationModelFile) return

        $(this.$refs.brsAttestationModelButton).attr('disabled', 'true')
        $(this.$refs.brsAttestationModelButton).children('i').removeClass('hidden')
        this.brsAttestationModelError = null
        this.brsAttestationModelSuccess = null

        const fileReader = new FileReader()
        fileReader.readAsDataURL(this.brsAttestationModelFile)
        fileReader.onload = () => {
            const apiService = new ApiService()
            const req = {
                fileName: this.brsAttestationModelFile.name,
                fileBase64: fileReader.result as string,
            }
            apiService.postOperationBrsAttestationModel(this.opeId, req)
                .then(() => {
                    $(this.$refs.brsAttestationModelButton).children('i').addClass('hidden')
                    $(this.$refs.brsAttestationModelButton).removeAttr('disabled')
                    this.brsAttestationModelSuccess = 'Le modèle a été envoyé avec succès'
                    this.brsAttestationModelFile = null
                })
                .catch(() => {
                    $(this.$refs.brsAttestationModelButton).children('i').addClass('hidden')
                    $(this.$refs.brsAttestationModelButton).removeAttr('disabled')
                    this.brsAttestationModelError = "Le modèle n'a pas pu être envoyé."
                })
        }
    }

    uploadPurchaseLetterModel() {
        if (!this.purchaseLetterModelFile) return

        $(this.$refs.purchaseLetterModelButton).attr('disabled', 'true')
        $(this.$refs.purchaseLetterModelButton).children('i').removeClass('hidden')
        this.purchaseLetterModelError = null
        this.purchaseLetterModelSuccess = null

        const fileReader = new FileReader()
        fileReader.readAsDataURL(this.purchaseLetterModelFile)
        fileReader.onload = () => {
            const apiService = new ApiService()
            const req = {
                fileName: this.purchaseLetterModelFile.name,
                fileBase64: fileReader.result as string,
            }
            apiService.postOperationPurchaseLetterModel(this.opeId, req)
                .then(() => {
                    $(this.$refs.purchaseLetterModelButton).children('i').addClass('hidden')
                    $(this.$refs.purchaseLetterModelButton).removeAttr('disabled')
                    this.purchaseLetterModelSuccess = 'Le modèle a été envoyé avec succès'
                    this.purchaseLetterModelFile = null
                })
                .catch(() => {
                    $(this.$refs.purchaseLetterModelButton).children('i').addClass('hidden')
                    $(this.$refs.purchaseLetterModelButton).removeAttr('disabled')
                    this.purchaseLetterModelError = "Le modèle n'a pas pu être envoyé."
                })
        }
    }
}
